// A destroyed TipTap editor is not merely idle — `destroy()` tears down its
// command manager and view, so reading `editor.commands` or `editor.state`
// THROWS (`Cannot read properties of null (reading 'commands')`) rather than
// returning undefined. `editor?.commands` therefore guards nothing: the
// optional chain only covers a missing editor, not a torn-down one.
//
// This matters because React keeps an imperative handle alive across that
// teardown, so work queued before it — a post-then-refocus retry, a debounced
// save — still reaches in afterwards.

export interface DestroyableEditor {
    isDestroyed?: boolean
}

export function isEditorLive<T extends DestroyableEditor>(
    editor: T | null | undefined,
): editor is T {
    return !!editor && editor.isDestroyed !== true
}

// The editor if it can still be commanded, else null — for the common
// `const live = liveEditor(editor); if (!live) return` shape.
export function liveEditor<T extends DestroyableEditor>(editor: T | null | undefined): T | null {
    return isEditorLive(editor) ? editor : null
}
